let folder = 'technologie/meridian'
export const state = () => ({
  meta: null,
  intro: null,
  steps: null,
  quote: null,
  details: null,
  integration: null,
  quoteSlider: null,
  synergy: null,
  contact: null,
  download: null
})
export const getters = {
  meta(state) {
    return state.meta
  },
  intro(state) {
    return state.intro
  },
  steps(state) {
    return state.steps
  },
  quote(state) {
    return state.quote
  },
  details(state) {
    return state.details
  },
  integration(state) {
    return state.integration
  },
  quoteSlider(state) {
    return state.quoteSlider
  },
  synergy(state) {
    return state.synergy
  },
  contact(state) {
    return state.contact
  },
  download(state) {
    return state.download
  }
}
export const mutations = {
  setMeta(state, { data }) {
    state.meta = data
  },
  setIntro(state, { data }) {
    state.intro = data
  },
  setSteps(state, { data }) {
    state.steps = data
  },
  setQuote(state, { data }) {
    state.quote = data
  },
  setDetails(state, { data }) {
    state.details = data
  },
  setIntegration(state, { data }) {
    state.integration = data
  },
  setQuoteSlider(state, { data }) {
    state.quoteSlider = data
  },
  setOptimization(state, { data }) {
    state.optimization = data
  },
  setBoxes(state, { data }) {
    state.boxes = data
  },
  setSynergy(state, { data }) {
    state.synergy = data
  },
  setContact(state, { data }) {
    state.contact = data
  },
  setDownload(state, { data }) {
    state.download = data
  }
}
export const actions = {
  getMeta({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/meta.json`)
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getIntro({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/intro.json`)
      .then((res) => {
        commit('setIntro', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getSteps({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/steps.json`)
      .then((res) => {
        commit('setSteps', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getQuote({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/quote.json`)
      .then((res) => {
        commit('setQuote', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getDetails({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/details.json`)
      .then((res) => {
        commit('setDetails', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getIntegration({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/integration.json`)
      .then((res) => {
        commit('setIntegration', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getQuoteSlider({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/quoteSlider.json`)
      .then((res) => {
        commit('setQuoteSlider', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getSynergy({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/synergy.json`)
      .then((res) => {
        commit('setSynergy', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContact({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/contact.json`)
      .then((res) => {
        commit('setContact', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getDownload({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/download.json`)
      .then((res) => {
        commit('setDownload', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
